import RemoteObject from './RemoteObject';

export default class PagedObjects {
  constructor(retObject = { objects: [], totalCount: 0, listRefId: 0 }) {
    this.objects = retObject.objects.map(object => (object ? new RemoteObject(object) : null));
    this.totalCount = retObject.totalCount;
    this.listRefId = retObject.listRefId;
  }

  getRemoteObjects() {
    return this.objects;
  }

  getCount() {
    return this.getRemoteObjects().length;
  }

  isEmpty() {
    return this.getCount() === 0;
  }

  isNotEmpty() {
    return !this.isEmpty();
  }

  map(callback, thisArg) {
    return this.getRemoteObjects().map(callback, thisArg);
  }

  forEach(callback, thisArg) {
    return this.getRemoteObjects().forEach(callback, thisArg);
  }

  getTotalCount() {
    return this.totalCount;
  }

  getListRefId() {
    return this.listRefId;
  }

  hasListRefId() {
    return this.getListRefId() !== 0;
  }

  getLastId() {
    if (this.getCount() > 0) {
      return this.getRemoteObjects()[this.getCount() - 1].getId();
    } else {
      return Number.MAX_SAFE_INTEGER;
    }
  }
}
